document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('[data-cookbook-3option]');
  if (!section) return;

  // Restock Rocket suppression. Its sticky "Notify me" sidebar uses fixed
  // position + z-index 123123 and overlaps the buybox. The app injects
  // asynchronously, so remove on mount, again on short delays, and via a
  // MutationObserver until the page has stabilised.
  const hideRestockRocket = () => {
    document
      .querySelectorAll(
        '.restock-rocket-button-container-float-right, ' +
        '.restock-rocket-button-container-float-left, ' +
        '.restock-rocket-button-container, ' +
        '.restock-rocket-button-float'
      )
      .forEach((el) => el.remove());
  };
  hideRestockRocket();
  setTimeout(hideRestockRocket, 500);
  setTimeout(hideRestockRocket, 1500);
  const observer = new MutationObserver(hideRestockRocket);
  observer.observe(document.body, { childList: true, subtree: false });
  setTimeout(() => observer.disconnect(), 2000);

  // Dialog open/close (event-delegated so it survives section re-renders in
  // the theme editor).
  section.addEventListener('click', function (e) {
    if (e.target.hasAttribute('data-dialog-open')) {
      e.preventDefault();
      const dialogId = e.target.getAttribute('data-dialog-open');
      const dialog = section.querySelector(`#${dialogId}`);
      if (dialog && dialog instanceof HTMLDialogElement) {
        dialog.showModal();
      }
    }
    if (e.target.hasAttribute('data-dialog-close')) {
      e.preventDefault();
      const dialog = e.target.closest('dialog');
      if (dialog && dialog instanceof HTMLDialogElement) {
        dialog.close();
      }
    }
  });

  // Backdrop click closes any open dialog.
  section.querySelectorAll('dialog').forEach((dialog) => {
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
  });

  // Quantity stepper (+/-) on the stock row. The input is form-associated with
  // the active add-to-cart form via its `form` attribute, so changing the value
  // is all that's needed — submission carries the quantity natively.
  section.addEventListener('click', function (e) {
    const minus = e.target.closest('[data-qty-minus]');
    const plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    const wrap = e.target.closest('.cookbook-3option__qty');
    const input = wrap && wrap.querySelector('[data-qty-input]');
    if (!input) return;
    let v = parseInt(input.value, 10);
    if (isNaN(v) || v < 1) v = 1;
    const min = parseInt(input.min, 10) || 1;
    v = minus ? Math.max(min, v - 1) : v + 1;
    input.value = v;
  });

  // Guard the typed value: never allow below 1 or a non-number.
  section.addEventListener('change', function (e) {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    let v = parseInt(input.value, 10);
    const min = parseInt(input.min, 10) || 1;
    if (isNaN(v) || v < min) v = min;
    input.value = v;
  });

  // Desktop hover: swap the gallery's CURRENT main image to the hovered format's
  // product image (mouse-only, never interferes with tap/scroll on touch). Works
  // with the native product-media gallery (swap the selected flickity slide's <img>)
  // AND the single-image fallback (home / no media). The main image is re-resolved
  // on every hover so it stays correct after the customer clicks a thumbnail.
  const canHover = window.matchMedia('(min-width: 740px) and (hover: hover)').matches;
  if (canHover) {
    const cards = section.querySelectorAll('.cookbook-3option__card[data-hover-image]');
    // Preload the format images so the swap is instant (no flash).
    cards.forEach((card) => {
      const url = card.getAttribute('data-hover-image');
      if (url) { const img = new Image(); img.src = url; }
    });
    const getMainImg = () =>
      section.querySelector('.cookbook-3option__hero-image') ||
      section.querySelector('.product__media-item.is-selected img') ||
      section.querySelector('.product__media-image-wrapper img');
    let saved = null; // { img, src, srcset } captured at hover-in so we can restore exactly
    cards.forEach((card) => {
      const url = card.getAttribute('data-hover-image');
      if (!url) return;
      card.addEventListener('mouseenter', () => {
        const img = getMainImg();
        if (!img) return;
        saved = { img: img, src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
        img.setAttribute('srcset', '');
        img.setAttribute('src', url);
      });
      card.addEventListener('mouseleave', () => {
        if (!saved) return;
        if (saved.src) saved.img.setAttribute('src', saved.src);
        if (saved.srcset) saved.img.setAttribute('srcset', saved.srcset);
        else saved.img.removeAttribute('srcset');
        saved = null;
      });
    });
  }

  // Mirror the buybox star bar's count + rating to the Fera widget's actual
  // numbers for THIS product (Sean 2026-06-06). The top bar server-renders a
  // fallback (e.g. 8084); Fera renders async lower down with the product's real
  // total. Once it appears, copy its count (and rating) up so the top number
  // always matches the bottom widget, per product. No-op if Fera never loads.
  (function syncRatingToFera() {
    const link = section.querySelector('.cookbook-3option__rating-link');
    if (!link) return;
    const valueEl = link.querySelector('.cookbook-3option__rating-value');
    const countEl = link.querySelector('.cookbook-3option__rating-count');
    const starsEl = link.querySelector('.cookbook-3option__stars');
    if (!countEl) return;

    const renderStars = (rating) => {
      if (!starsEl) return;
      const floor = Math.floor(rating);
      const rem = rating - floor;
      let html = '';
      for (let i = 1; i <= 5; i++) {
        let cls = 'cookbook-3option__star';
        if (i <= floor) cls += ' is-on';
        else if (i === floor + 1 && rem >= 0.75) cls += ' is-on';
        else if (i === floor + 1 && rem >= 0.25) cls += ' is-half';
        html += '<span class="' + cls + '">★</span>';
      }
      starsEl.innerHTML = html;
    };

    const apply = () => {
      const c = document.querySelector(
        '.fera-widget-container, [data-fera-container="product_reviews"]'
      );
      if (!c) return false;
      const txt = c.innerText || '';
      const rev = txt.match(/([\d,]+)\s*reviews?/i);
      if (!rev) return false;
      const count = parseInt(rev[1].replace(/,/g, ''), 10);
      if (!count || count < 1) return false;
      countEl.textContent = '(' + count + ')';
      const rat = txt.match(/\b([0-5]\.\d)\b/);
      if (rat && valueEl) {
        const rating = parseFloat(rat[1]);
        valueEl.textContent = rating.toFixed(1);
        renderStars(rating);
        link.setAttribute('aria-label', 'See ' + count + ' reviews, rated ' + rating.toFixed(1) + ' out of 5');
      } else {
        link.setAttribute('aria-label', 'See ' + count + ' reviews');
      }
      return true;
    };

    if (apply()) return;
    let tries = 0;
    const iv = setInterval(() => {
      if (apply() || ++tries > 40) clearInterval(iv); // poll ~20s max
    }, 500);
  })();
});
